/* 
 * Javascript for umem.org navigation.
 * 
 * Opens hidden sub-links for the sidebar navigation.
 */

import $ from 'jquery';

$(function(){
	$('.submenu-trigger').on('click', function(event){
		$(event.delegateTarget).find('span').toggleClass('caret caret-side');
		
		$($(event.delegateTarget).attr('data-target')).toggleClass('hide');

		// If triggering element is a link, prevent event propagation.
		if($(event.delegateTarget).is("a")){
			event.preventDefault();
		}
	});
});



// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/include/navigation.js